<div class="infoPopup markdownContent">
  <div class="infoPopup__text" [innerHTML]="'info-popup-text--APPLE_WATCH' | tmd"></div>
</div>
